import { observable, computed, runInAction } from 'mobx';
import { post } from '../utils';

/**
 * 1、首页列表
 */
class CouponGoodsList {
    static PAGE_SIZE = 20;
    private route: string;
    private params: any;
    private header: Object;

    @observable
    public firstFetched: boolean = false;
    @observable
    public isHomeLast: boolean = true;
    @observable
    public isEmpty: boolean = false;
    @observable
    public lists: any[] = [];
    @observable
    public page: any = 1;
    @observable
    public isReady: boolean = false;
    @observable
    public cursor: any = '';
    @observable
    private isLastPage: boolean = true;

    constructor(params: any, header?: Object) {
        this.route = params.url;
        this.params = params;
        this.header = header || {};
    }

    updateParams(key, val) {
        this.params[key] = val;
    }

    @computed
    get canFetch() {
        if (this.isEmpty) {
            return false;
        }
        return !this.isLastPage;
    }

    async fetch(page, callback, errs?) {
        let obj = Object.assign({
            count: CouponGoodsList.PAGE_SIZE,
            cursor: this.cursor
        }, this.params);
        if (this.cursor == null && page != 1) {
            return callback && callback([], null); // 返回库存和页码
        }
        if (page == 1) {
            obj.cursor = 0;
        }
        post(this.route, obj).then((d) => {
            this.isReady = true;
            let data;
            if (d.data) {
                data = d.data.list;
                this.cursor = d.data.cursor;
                runInAction(() => {
                    if (page == 1) {
                        this.lists = [];
                        // data = d.data;
                        this.isEmpty = data.length == 0;
                    }
                    this.firstFetched = true;
                    this.isLastPage = data.length < CouponGoodsList.PAGE_SIZE;
                    let price = 0, len = 0;
                    let LowerArr: any[] = []; // 下架
                    let lootArr: any[] = []; // 抢光
                    let normalArr: any[] = []; // 正常
                    data.forEach((item) => {
                        item.key = item.ciId + '' + Date.now();
                        price += (item.cartPrice * 100); // 合计
                        if (this.route == 'newproduct/carts/v1') {
                            item.isquan = false; // 默认没选中
                            item.isEditQuan = false; // 默认编辑没选中
                            item.skuItem.inventory === 0 && item.skuItem.isOnline !== false && lootArr.push(item);
                            item.skuItem.isOnline === false && LowerArr.push(item);
                            (item.skuItem.inventory !== 0 && item.skuItem.isOnline !== false) && normalArr.push(item);
                        }
        
                        if (this.route.indexOf('searchapi/coupon') != -1 ) {
                            len++;
                        }
                       
                        this.lists.push(item);
                    });
                    if (this.route == 'newproduct/carts/v1') { // 购物车内失效商品应该展示在有效商品的下方，已下架的商品置于已抢光商品的下方
                        this.lists = [...normalArr, ...lootArr, ...LowerArr];
                    }
                    if (this.route == 'newproduct/carts/v1' || this.route == 'newproduct/carts/v1/skuIds') { // 购物车页面和购物车结算页
                        callback && callback(data, price / 100, len); // 返回列表 价格 和库存为0
                    } else {
                        callback && callback(data, this.cursor); // 返回库存和页码
                    }
                });
            } else {
                callback && callback([]);
                this.firstFetched = true;
            }
        }).catch((err) => {
            errs && errs(err);
        });
    }

    @computed
    get list() {
        return this.lists.slice();
    }
}

export default CouponGoodsList;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/coupongoodsList.ts